import {defineSlotRecipe} from '@chakra-ui/react3'

/**
 * Recipe for the "How to use / Documents" panel of the PDP details accordion.
 */
export default defineSlotRecipe({
    slots: [
        'container',
        'panel',
        'panelColumn',
        'columnHeading',
        'documents',
        'documentLink',
        'assemblyContainer',
        'videoItem'
    ],
    base: {
        container: {
            flexDirection: 'column',
            gap: 'spacing-32'
        },
        panel: {
            flexDirection: {base: 'column', s: 'row'},
            gap: {base: 'spacing-40', s: 'spacing-90'}
        },
        panelColumn: {
            flexDirection: 'column',
            width: {base: '100%', s: '50%'},
            gap: 'spacing-16'
        },
        columnHeading: {
            textStyle: 'heading.large',
            color: 'text.primary',
            textAlign: 'start'
        },
        documents: {
            gap: 'spacing-8',
            listStyleType: 'none',
            alignItems: 'flex-start'
        },
        documentLink: {
            maxWidth: '100%'
        },
        assemblyContainer: {
            flexDirection: 'column',
            gap: {base: 'spacing-16', s: 'spacing-32'}
        },
        videoItem: {
            position: 'relative',
            width: '100%',
            overflow: 'hidden'
        }
    }
})
